import { render, staticRenderFns } from "./editAfterSaleService.vue?vue&type=template&id=2bfbe9bf&scoped=true"
import script from "./editAfterSaleService.vue?vue&type=script&lang=js"
export * from "./editAfterSaleService.vue?vue&type=script&lang=js"
import style0 from "./editAfterSaleService.vue?vue&type=style&index=0&id=2bfbe9bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfbe9bf",
  null
  
)

export default component.exports